import API from "api/api/API";
import TenantAPI from "./TenantAPI";
import React from "react";
import Cookies from "js-cookie";

export default class FolderAPI {
  static async duplicateFolder(workspaceID, folderID) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/folders/${folderID}/duplicate`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }
}
